import Axios from '../../axiosConfig';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import Contact from '../../types/contact';
import { BACKEND_URL } from '../../config';

configure({ enforceActions: 'observed' });

export default class ContactModule {
    private contactInfo: Contact | null = null;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public async fetchContact(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'controlData/contactInfo',
            withCredentials: true,
        });
        if (response?.status === 200) runInAction(() => (this.contactInfo = response.data));
    }

    public get contact(): Contact | null {
        return this.contactInfo;
    }
}
